import { createBrowserRouter, Params, redirect } from 'react-router-dom'
import Layout from 'src/pages/layout'
import Mkt01Form from 'src/pages/mkt01Form'
import Mkt02Form from 'src/pages/mkt02Form'
import Mkt03 from 'src/pages/Mkt03'
import Mkt04 from 'src/pages/Mkt04'
import Mkt05 from 'src/pages/Mkt05'

import TermsModal from 'src/components/common/TermsModal'
import { defaultTheme, themeV1, themeV2 } from 'src/styles/theme'
import ErrorBoundaryPage from 'src/pages/error'

const telecomCheckLoader = ({ params }: { params: Params<string> }) => {
  const paramCheck = !!params.telecom && ['0', '1', '2'].includes(params.telecom)

  if (paramCheck) return true
  else {
    const redirectUrl = !!params.pcode ? `/join/${params.pcode}` : '/join'
    return redirect(redirectUrl)
  }
}

export const router = createBrowserRouter([
  {
    errorElement: <ErrorBoundaryPage />,
    children: [
      {
        element: <Layout theme={defaultTheme} />,
        children: [
          {
            element: <Mkt01Form />,
            path: '/mkt01/:pcode/:requestID',
            children: [
              {
                path: ':telecom',
                loader: telecomCheckLoader,
                children: [{ path: ':authKey/:telecom' }],
              },
            ],
          },
          {
            element: <Mkt02Form />,
            path: '/mkt02/:pcode/:requestID',
            children: [
              {
                path: ':telecom',
                loader: telecomCheckLoader,
                children: [{ path: ':authKey/:telecom' }],
              },
            ],
          },
        ],
      },
      {
        element: <Layout theme={themeV1} />,
        children: [
          {
            element: <Mkt03 />,
            path: '/mkt03/:pcode/:requestID',
            children: [
              {
                path: ':telecom',
                loader: telecomCheckLoader,
              },
            ],
          },
          { element: <TermsModal />, path: '/terms/:requestID/:telecom/:termsIdx/:termsOrderIdx' },
        ],
      },
      {
        element: <Layout theme={themeV2} />,
        children: [
          {
            element: <Mkt04 />,
            path: '/mkt04/:pcode/:requestID',
            children: [
              {
                path: ':telecom',
                loader: telecomCheckLoader,
              },
            ],
          },
          {
            element: <Mkt05 />,
            path: '/mkt05/:pcode/:requestID',
            children: [
              {
                path: ':telecom',
                loader: telecomCheckLoader,
              },
            ],
          },
        ],
      },
    ],
  },
])
